import React from 'react';
import { injectIntl } from 'react-intl';
import { Forgot, Form, FormGroup, Input, Submit, SwitchPassword } from '..';
import { Auth } from '../../../utils/utils.api';
import { getErrorMessage } from '../../../utils/errorMessage';
import { InjectedIntlProps } from '../../../doctrine.types';

type Props = InjectedIntlProps & {
  switchToForgotPassword: (
    event: React.MouseEvent<HTMLSpanElement, MouseEvent>,
  ) => void;
};

type State = {
  email: string;
  password: string;
  shoulShowPassword: boolean;
  isLoading: boolean;
  errorMessage: string;
};

export class RawConnectionForm extends React.Component<Props, State> {
  state: State = {
    email: '',
    password: '',
    shoulShowPassword: false,
    isLoading: false,
    errorMessage: '',
  };

  onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const { email, password } = this.state;
    this.setState({ isLoading: true });

    Auth.login({ email, password })
      .then(() => window.location.reload())
      .catch(error => {
        const errorMessage = getErrorMessage(error.response);
        this.setState({
          errorMessage,
        });
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  render() {
    const { password, shoulShowPassword, isLoading, errorMessage } = this.state;
    const { switchToForgotPassword, intl } = this.props;
    return (
      <Form onSubmit={this.onSubmit} data-test-id="form">
        <FormGroup>
          <Input
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              this.setState({ email: e.target.value })
            }
            value={this.state.email}
            placeholder={intl.formatMessage({
              id: 'login/components/connection-form/ConnectionForm.tsx/1',
            })}
            type="email"
            autoComplete="email"
            id="modal_login_email"
            required
            spellCheck={false}
          />
        </FormGroup>

        <FormGroup>
          <Input
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              this.setState({ password: e.target.value })
            }
            value={password}
            placeholder={intl.formatMessage({
              id: 'login/components/connection-form/ConnectionForm.tsx/2',
            })}
            autoComplete="current-password"
            type={shoulShowPassword ? 'text' : 'password'}
            id="modal_login_password"
            name="password"
            required
            spellCheck={false}
          />
        </FormGroup>
        <SwitchPassword
          showPassword={shoulShowPassword}
          onClick={() => {
            this.setState(state => ({
              shoulShowPassword: !state.shoulShowPassword,
            }));
          }}
        />
        {!!errorMessage && (
          <div
            className="modal__form__error"
            dangerouslySetInnerHTML={{ __html: errorMessage }}
            data-test-id="login-error"
          />
        )}

        <FormGroup>
          <Submit loading={isLoading} />
        </FormGroup>
        <Forgot onClick={switchToForgotPassword} />
      </Form>
    );
  }
}
export const ConnectionForm = injectIntl(RawConnectionForm);
